import { ReactComponent as Logo } from '@elotech/arc/src/assets/img/modules/oxy-administrativo.svg';
import {
  Header,
  Icon,
  KeycloakService,
  useOnClickOutside
} from '@elotech/components';
import { getBooleanValue } from 'common/hooks';
import { useParametro } from 'hooks';
import { StorageService } from 'libs';
import { OCULTAR_LOGIN_OXY_CIDADAO } from 'pages/parametros/Parametros';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ProtocoloAuthService } from 'service';
import { AuthActions, EntidadeActions } from 'state';
import { getConfigSelector, getEntidadeSelector } from 'state/selectors';
import { isAuthenticated } from 'utils';

export const AppHeader = () => {
  const history = useHistory();
  const contentRef = useRef(null);
  const dispatch = useDispatch();
  const [isLoginActive, setIsLoginActive] = useState(false);
  const { entidadeLogada, config } = useSelector(state => ({
    entidadeLogada: getEntidadeSelector(state),
    config: getConfigSelector(state)
  }));
  const [ocultaOxyCidadao] = useParametro({
    id: OCULTAR_LOGIN_OXY_CIDADAO,
    getValue: getBooleanValue
  });

  useOnClickOutside(contentRef, () => {
    setIsLoginActive(false);
  });

  const isLogged = isAuthenticated();

  const onLogout = () => {
    StorageService.removeItem('entidade');
    ProtocoloAuthService.clearAuthentication();
    const redirectUri = `${ProtocoloAuthService.getHost()}/protocolo/consultaProcesso`;

    if (config.isCloud) {
      KeycloakService.logout({
        redirectUri
      });
    } else {
      dispatch(AuthActions.logout());
      dispatch(EntidadeActions.clearEntidade());
      window.location.href = redirectUri;
    }
  };

  const onClickNovidadesVersao = () => {
    window.open('https://elotech.movidesk.com/kb/category/oxy-protocolo');
  };

  const goToOxyCidadao = () => {
    window.location.href = config.urlOxyCidadao;
  };

  const onLogin = () => {
    StorageService.removeItem('entidade');

    if (config.isCloud) {
      window.location.search = '?login=true';
    } else if (config.integradoUnico || config.unicoParcial) {
      ProtocoloAuthService.redirectToLoginUnico();
    } else {
      history.push('/login');
    }
  };

  const renderFeatures = () => {
    if (!isLogged) {
      return (
        <ul className="header-features">
          {config.isSelecionaEntidade && (
            <li
              title="Trocar Entidade"
              onClick={() => history.push('/selecionar-entidade')}
            >
              <Icon icon="building" className="icon" />
              <small className="hidden-xs">Trocar Entidade</small>
            </li>
          )}
          <li
            title="Login"
            className={isLoginActive ? 'active' : ''}
            onClick={() => setIsLoginActive(prev => !prev)}
          >
            <Icon icon="user" className="icon" />
            <small className="hidden-xs">Login</small>
          </li>
        </ul>
      );
    }

    if (isLogged) {
      return (
        <>
          <Header.Features.AccessibilityButton />
          <Header.Features.NotificationButton />
          <Header.Features.AjustesButton />
          {config.isCloud && <Header.Features.ModulosButton />}
        </>
      );
    }

    return null;
  };

  const renderContentLogged = () => {
    return (
      <>
        <Header.FeaturesContent.AccessibilityContent />
        <Header.FeaturesContent.EloNotificationContent />
        <Header.FeaturesContent.AjustesContent
          autoHeight
          showNovidadesVersao
          hideAccount={!config.isCloud}
          onLogout={onLogout}
          onClickNovidadesVersao={onClickNovidadesVersao}
        />
        <Header.FeaturesContent.ModulosContent />
      </>
    );
  };

  const renderContentNotLogged = () => {
    return (
      <div className="features-user auto-height active" ref={contentRef}>
        <h2 className="title">Login</h2>
        <ul className="user-actions">
          {!!config.urlOxyCidadao && !ocultaOxyCidadao && (
            <li onClick={goToOxyCidadao}>
              <Icon icon="house-user" className="icon" />
              Cidadão
            </li>
          )}
          <li onClick={onLogin}>
            <Icon icon="user-tie" className="icon" />
            Servidor
          </li>
        </ul>
      </div>
    );
  };

  return (
    <>
      <Header
        showToggleButton
        logoModulo={Logo}
        brasao={entidadeLogada?.brasao}
        title={isLogged ? entidadeLogada?.nome || '' : config.entidade || ''}
      >
        <Header.Features>{renderFeatures()}</Header.Features>
        {isLogged && (
          <Header.FeaturesContent>
            {renderContentLogged()}
          </Header.FeaturesContent>
        )}
      </Header>
      {isLoginActive && (
        <Header.FeaturesContent>
          {renderContentNotLogged()}
        </Header.FeaturesContent>
      )}
    </>
  );
};
